import { render } from "./sms-verification.vue?vue&type=template&id=5fedbff5&scoped=true"
import script from "./sms-verification.vue?vue&type=script&lang=js"
export * from "./sms-verification.vue?vue&type=script&lang=js"

import "./sms-verification.vue?vue&type=style&index=0&id=5fedbff5&lang=css"
import "./sms-verification.vue?vue&type=style&index=1&id=5fedbff5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fedbff5"]])

export default __exports__